import config from '../config'

export const replaceBucketUrlWithCdnUrl = value => {
  try {
    if (!value) {
      return value
    }
    let assetUrl
    if (typeof value === 'object') {
      assetUrl = value.backgroundImage
    } else {
      assetUrl = value
    }
    const index = assetUrl.indexOf(config.firebase.storageBucket)
    let newAssetUrl
    if (index !== -1) {
      const length = config.firebase.storageBucket.length
      let startIndex = index + length
      if (assetUrl.substring(startIndex, startIndex + 2) === '/o') {
        startIndex += 2
      }
      newAssetUrl = `${config.firebase.cdnUrl}${assetUrl.substring(
        startIndex,
        assetUrl.length
      )}`
    }
    if (typeof value === 'object') {
      return index !== -1 ? { backgroundImage: `url(${newAssetUrl}` } : value
    }
    return index !== -1 ? newAssetUrl : value
  } catch (e) {
    console.log(e)
    return value
  }
}
